module.exports = __webpack_public_path__ + "static/img/Daniel_Talia_desktop.17c764e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel_Talia_desktop.jpg
// module id = CWZ8
// module chunks = 0